import React from 'react'
import { Form, Button, TextArea} from 'semantic-ui-react'

export default class AseComments extends React.Component{
  constructor(props){
    super(props)
    this.state = {isEditing: false, value: props.aseComments}
  }

  onChange = (event) => {
    this.setState({value: event.target.value})
  }

  onSave = () => {
    const {isEditing, value} = this.state
    this.setState({isEditing: !isEditing})
    if(isEditing) this.props.onSave(value)
  }

  render() {
    const {isEditing, value } = this.state
    const { aseComments, hideEdit, isFixedPrice, onSubmit} = this.props

    return (
      <div>
        {hideEdit ?
          <Button
            style={{ marginTop: "10px" }}
            type="button"
            size='mini'
            color='orange'
            onClick={onSubmit}>Submit
          </Button>
          :
          <div>
            <Form style={{alignSelf:"flex-start"}}>
              <div style={{ "whiteSpace": "pre-wrap"}}>
                {isEditing ?
                  <TextArea
                    rows="10"
                    style={{width: isFixedPrice ? '130px' : '270px'}}
                    value={value}
                    onChange={this.onChange}
                  />
                  :
                  <p>{value}</p>
                }
              </div>
            </Form>
            {aseComments && !hideEdit &&
              <Button
                style={{ marginTop: "10px" }}
                size="mini" color="orange" s
                onClick={this.onSave}
              >
                {isEditing ? "Done" : "Edit"}
              </Button>
            }
            {isEditing &&
              <Button
                style={{ marginTop: "10px" }}
                size="mini" color="grey"
                onClick={() => {this.setState({isEditing: false, value: this.props.aseComments})}}>
                Cancel
              </Button>
            }
          </div>
        }
      </div>
    )
  }
}

